var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1688(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1688",
    "data-name": "Groupe 1688",
    transform: "translate(-10841 -1300)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1297",
    "data-name": "Rectangle 1297",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(10841 1300)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_like-shapes",
    "data-name": "vuesax/linear/like-shapes",
    transform: "translate(10315 1083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like-shapes",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.482.682a3.107,3.107,0,0,1,3.885,0l2.436,2.1a3.417,3.417,0,0,0,1.942.725h2.621a2.987,2.987,0,0,1,2.975,2.975V9.1a3.458,3.458,0,0,0,.725,1.943l2.1,2.436a3.107,3.107,0,0,1,0,3.885l-2.1,2.436a3.417,3.417,0,0,0-.725,1.943v2.621a2.987,2.987,0,0,1-2.975,2.975H21.745a3.458,3.458,0,0,0-1.942.725l-2.436,2.1a3.107,3.107,0,0,1-3.885,0l-2.436-2.1A3.417,3.417,0,0,0,9.1,27.338H6.436a2.987,2.987,0,0,1-2.975-2.975V21.726A3.508,3.508,0,0,0,2.752,19.8L.671,17.348a3.1,3.1,0,0,1,0-3.854l2.081-2.451a3.508,3.508,0,0,0,.709-1.927V6.479A2.987,2.987,0,0,1,6.436,3.5H9.1a3.458,3.458,0,0,0,1.943-.725Z",
    transform: "translate(3.091 3.095)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.563 11.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.031,11.342l2.235,1.727a2.207,2.207,0,0,0,1.372.432H6.367a2.167,2.167,0,0,0,2.02-1.511l1.727-5.273A1.361,1.361,0,0,0,8.741,4.836H5.858a.732.732,0,0,1-.725-.863l.355-2.313A1.434,1.434,0,0,0,4.548.073,1.452,1.452,0,0,0,2.96.581L0,4.975",
    transform: "translate(3.654)",
    fill: "none",
    stroke: "#1b7afa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,8.433V1.372C0,.355.432,0,1.449,0h.725c1,0,1.449.355,1.449,1.372V8.433c0,1-.432,1.372-1.449,1.372H1.449C.432,9.8,0,9.45,0,8.433Z",
    transform: "translate(0 2.909)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H37V37H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1688);
export default __webpack_public_path__ + "static/media/Groupe-1688.c59cd9c0c3f11431871a3498f081c9f7.svg";
export { ForwardRef as ReactComponent };